import { render, staticRenderFns } from "./privacy-summary.vue?vue&type=template&id=6e68b238&scoped=true"
import script from "./privacy-summary.vue?vue&type=script&lang=js"
export * from "./privacy-summary.vue?vue&type=script&lang=js"
import style0 from "./privacy-summary.vue?vue&type=style&index=0&id=6e68b238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e68b238",
  null
  
)

export default component.exports